import React from 'react';
import classnames from 'classnames';
import get from 'lodash/get';

// Types
import { Color } from '../../colors/Colors.types';

// Constants
import Colors from '../../colors/ColorConstants';

// Styles
import './WpText.scss';

export type TextElement = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';

export type Variant =
  | 'titleLg'
  | 'titleMd'
  | 'titleSm'
  | 'titleXs'
  | 'bodyXxl'
  | 'bodyXl'
  | 'bodyLg'
  | 'bodyMd'
  | 'bodySm'
  | 'bodyXs';

export interface TextProps {
  /** The element type */
  tag?: TextElement;
  /** Adjust weight of text */
  variant?: Variant;
  /** Text to display */
  children: React.ReactNode;
  /** Color of text */
  color?: Color;
  /** HTML id attribute */
  id?: string;
  /** Truncate text overflow with ellipsis */
  truncate?: boolean;
  /** Capitize */
  caps?: boolean;
  /** apply bold styling to text */
  bold?: boolean;
  /** apply italic styling to text */
  italic?: boolean;
  /** apply zero margin to text */
  noMargin?: boolean;
  /** test id */
  qaTest?: string;
}

const WpText = ({
  tag = 'p',
  variant = 'bodyMd',
  children,
  color = 'gray-900',
  id,
  truncate = false,
  caps = false,
  bold = false,
  italic = false,
  noMargin = false,
  qaTest,
}: TextProps) => {
  const Component = tag;

  const baseClassName = 'WpText';
  const classes = classnames(
    baseClassName,
    `${baseClassName}--${variant}`,
    bold && `${baseClassName}--bold`,
    italic && `${baseClassName}--italic`,
    caps && `${baseClassName}--caps`,
    truncate && `${baseClassName}--truncate`,
    noMargin && `${baseClassName}--noMargin`
  );

  const colorMap = color.split('-');
  const textColor = get(Colors, `${colorMap[0]}.${colorMap[1]}`);
  return (
    <Component className={classes} {...(id && { id })} data-test={qaTest} style={{ color: textColor }}>
      {children}
    </Component>
  );
};

export default WpText;
